
import { FreeData } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { Model } from '../../../model/model';

/** 
 * point d'entrée générique pour les appels de service FD / FDV
 * va passer par le service :
 * - chargement du pool local
 * - comparaison des numRevs avec remote
 * - téléchargement si nécessaire
 * - merge
 * - alimentation du modèle
 */
export class FreedataCall extends WizCommand<any> {


  protected model: Model = null;

  constructor(model: Model, pCallback: Function = null) {
    super();
    this.model = model;
    if(pCallback) {
      this._callback = pCallback;
    }
  }

  private _callback: Function = this.voidCallback.bind(this); // retour par défaut pour traçabilité debug

  public wizExecute(): Promise<any> {
    return new Promise((resolve, reject) => {
      const backFromFind = (fd: FreeData[]) => {
        this._callback(fd);
        resolve(fd);
      };

      this.model.freedataSyncService.findFreedata(backFromFind);
    });
  }

  public voidCallback(result: any): void {
  }
}
